// 教师团队
import React, { useContext } from 'react';
import Image from 'next/image';
import { useTranslation } from 'next-i18next';
import cls from 'classnames';

import { PC, Mobile } from '@wukong/haomao';
import { MyContext } from '../../../../config/context-manager';

import Title from '../Title';
import styles from './style.module.scss';

interface RenderIntroduceImageProps {
  imgUrl: string;
  mUrl: string;
}
const RenderIntroduceImage: React.FC<RenderIntroduceImageProps> = ({ imgUrl, mUrl }) => {
  return (
    <>
      <PC>
        <div>
          <Image src={imgUrl} layout="fill" alt="" />
        </div>
      </PC>
      <Mobile>
        <div>
          <Image src={mUrl} layout="fill" alt="" />
        </div>
      </Mobile>
    </>
  );
};

const SubTitle = () => {
  const { t } = useTranslation('chineseSpecialty');
  return <div className={styles.title} dangerouslySetInnerHTML={{ __html: t('教师团队-副标题') }} />;
};

const Team = () => {
  const { t } = useTranslation('chineseSpecialty');
  const { locale } = useContext(MyContext);

  return (
    <section
      className={cls(styles.container, {
        [styles.localeEn]: locale === 'en',
      })}
    >
      <Title>{t('教师团队-主标题')}</Title>
      <SubTitle />
      <div className={styles.warpContainer}>
        <div className={`${styles.flexItem} ${styles.teacherQuality}`}>
          <div className={styles.introduceItem}>
            <RenderIntroduceImage
              imgUrl="/images/chinese-math-class/chinese/specil/team-introduce-a.png"
              mUrl="/images/chinese-math-class/chinese/specil/team-introduce-mobile-a.png"
            />
            <p className={styles.content}>{t('教师团队-内容-1')}</p>
          </div>
          <div className={styles.introduceItem}>
            <RenderIntroduceImage
              imgUrl="/images/chinese-math-class/chinese/specil/team-introduce-b.png"
              mUrl="/images/chinese-math-class/chinese/specil/team-introduce-mobile-b.png"
            />
            <p className={styles.content}>{t('教师团队-内容-2')}</p>
          </div>
          <div className={styles.introduceItem}>
            <RenderIntroduceImage
              imgUrl="/images/chinese-math-class/chinese/specil/team-introduce-c.png"
              mUrl="/images/chinese-math-class/chinese/specil/team-introduce-mobile-c.png"
            />
            <p className={styles.content}>{t('教师团队-内容-3')}</p>
          </div>
        </div>
        <div className={`${styles.flexItem} ${styles.teacherQualityImg}`}>
          <div className={styles.introduceBg}>
            <Image
              src="/images/chinese-math-class/chinese/specil/team-introduce-bg.png"
              width={865}
              height={631}
              layout="responsive"
              alt=""
            />
          </div>
          <div className={styles.introduceBg}>
            <Image
              src="/images/chinese-math-class/chinese/specil/team-introduce.png"
              width={865}
              height={631}
              layout="responsive"
              alt="悟空中文 教师团队"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Team;
